export default __webpack_public_path__ + "img/foundation.424a4e.jpeg";